export default __webpack_public_path__ + "static/media/skyvssea-landing-page.030faa6f.png";